import React from "react";
import { withRouter } from "react-router-dom";
import {  Button} from "reactstrap";

const Back = ({ history }) => (
  <Button type="button" color="secondary" className="mr-1" onClick={history.goBack}>Tagasi</Button>
);

export default withRouter(Back);